import { useTranslation } from "react-i18next";

import { getMeetingPreferencesLoadingStatus, getMeetingPreferencesWorkingHours } from "@lib/store";

import { useAppSelector, useModal } from "@hooks";
import { trackEvent } from "@lib/infrastructure";
import { ProfileCell } from "../styles";
import { Button } from "@molecules";
import { P } from "@quarks";
import { WorkingHoursModal } from "../WorkingHoursModal";
import { Loader } from "@atoms";
import { constructWorkingHoursLabel } from "@lib/logic";

export const WorkingHoursCell = () => {
  const { t } = useTranslation();
  const { addPages, openModal } = useModal();

  const workingHoursLoading = useAppSelector(getMeetingPreferencesLoadingStatus);
  const workingHoursData = useAppSelector(getMeetingPreferencesWorkingHours);
  const workingHoursLabel = constructWorkingHoursLabel(workingHoursData);

  const handleEditWorkingHours = () => {
    trackEvent("Profile_WorkingHours__Open");
    addPages([<WorkingHoursModal />]);
    openModal();
  };

  return (
    <ProfileCell>
      <P>{t("screen:WorkingHours")}</P>

      {workingHoursLoading !== "Loaded" ? (
        <Loader size="1rem" />
      ) : (
        <Button
          onClick={handleEditWorkingHours}
          button="tertiary"
          iconRight="caretRight">
          {workingHoursLabel}
        </Button>
      )}
    </ProfileCell>
  );
};
